import injectSheet from 'react-jss';

import Menu from './component';
import styles from './styles';

export default injectSheet(styles)(Menu);
